<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g
      fill="none"
      fill-rule="evenodd"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M5.556 5.444L4.084 3.931c-.574-.575-1.508-.575-2.082 0l-.856.856C.403 5.53.288 6.69.867 7.565c2.488 3.761 5.806 7.079 9.568 9.567.874.578 2.036.463 2.777-.279l.857-.857c.575-.574.575-1.506 0-2.08l-1.513-1.472c-.575-.574-1.759-.574-2.334 0l-.389.39C8.122 11.43 6.57 9.877 5.167 8.166l.389-.39c.574-.574.574-1.758 0-2.333z"
      />
      <g>
        <path
          d="M.5.5c3.898 0 8 3.602 8 7.5M.5 3C3.042 3 6 5.458 6 8M.5 6C1.5 6 3 7 3 8"
          transform="translate(9)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
